import { HeaderTitle, StackNavigator } from '@/components'
import { useStackScreenOptions } from '@/hooks'

// noinspection JSUnusedGlobalSymbols
export const unstable_settings = {
  initialRouteName: 'sign-in'
}

// eslint-disable-next-line react/display-name
export default () => {
  const screenOptions = useStackScreenOptions()

  return (
    <StackNavigator screenOptions={screenOptions}>
      <StackNavigator.Screen
        name='account-inactive'
        options={{
          headerTitle: 'Account Inactive'
        }}
      />
      <StackNavigator.Screen
        name='account-unverified'
        options={{
          headerTitle: 'Account Unverified'
        }}
      />
      <StackNavigator.Screen
        name='appeal'
        options={{
          headerTitle: 'Appeal Your Ban'
        }}
      />
      <StackNavigator.Screen
        name='banned'
        options={{
          headerLeft: () => null,
          headerTitle: 'Account Banned'
        }}
      />
      <StackNavigator.Screen
        name='forgot-password'
        options={{
          headerTitle: 'Forgot Password'
        }}
      />
      <StackNavigator.Screen
        name='reset-password'
        options={{
          headerTitle: 'Reset Password'
        }}
      />
      <StackNavigator.Screen
        name='sign-in'
        options={{
          headerLeft: () => null,
          headerTitle: () => (
            <HeaderTitle
              title='Sign In'
              subtitle='Welcome back!'
            />
          )
        }}
      />
      <StackNavigator.Screen
        name='sign-out'
        options={{
          headerLeft: () => null,
          headerTitle: 'Signing Out...'
        }}
      />
      <StackNavigator.Screen
        name='sign-up'
        options={{
          headerTitle: () => (
            <HeaderTitle
              title='Sign Up'
              subtitle="Let's Get Started!"
            />
          )
        }}
      />
    </StackNavigator>
  )
}
